import {
  useMutation,
  type MutationHookOptions,
  type MutationTuple,
  type TypedDocumentNode,
} from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { RenameContentTagDocument } from './rename.generated';

const useRename = <T, U>(
  document: TypedDocumentNode<T, U>,
  options: MutationHookOptions<T, U>,
): MutationTuple<T, U> => {
  const { t } = useTranslation();
  return useMutation(document, {
    ...useNotifications(document, {
      failure: t('api.content_tags.rename_error'),
      success: t('api.content_tags.rename_success'),
    }),
    ...options,
  });
};

export const useRenameContentTag = (options: ApiOptions<typeof RenameContentTagDocument> = {}) =>
  useRename(RenameContentTagDocument, options);
